import React from 'react'
import InternationalizedFormattedText from '../util/internationalized-formatted-text'

const NotFound = ({ classes }) => {
  return (
    <div className={classes.centeredText}>
      <InternationalizedFormattedText variant='h1' id='noMatch.title' className={classes.inlineText} />
    </div>
  )
}

export default NotFound
